/**
 * Composant Select
 * Menu déroulant stylisé
 */

import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    error?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ className, error, children, ...props }, ref) => {
        return (
            <select
                className={cn(
                    'flex h-10 w-full rounded-lg border bg-white dark:bg-[#0F172A] px-3 py-2 text-sm dark:text-[#F1F5F9]',
                    'focus:outline-none focus:ring-2 focus:ring-offset-0',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    'appearance-none cursor-pointer',
                    // Flèche custom
                    'bg-[url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'%2364748B\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'/%3E%3C/svg%3E")] bg-[length:20px] bg-[right_8px_center] bg-no-repeat pr-10',
                    error
                        ? 'border-[#EF4444] focus:ring-[#EF4444]/20'
                        : 'border-[#E2E8F0] dark:border-[#334155] focus:ring-[#0F2744]/20 focus:border-[#0F2744] dark:focus:border-[#3B82F6]',
                    className
                )}
                ref={ref}
                {...props}
            >
                {children}
            </select>
        );
    }
);

Select.displayName = 'Select';

export { Select };
